module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// ../node_modules/symbol-observable/index.js
// module id = 98
// module chunks = 0


// WEBPACK FOOTER //
// node_modules/symbol-observable/index.js